import { ref, watch, onMounted } from 'vue'

type Theme = 'light' | 'dark'

const theme = ref<Theme>('light')
const isInitialized = ref(false)

export function useTheme() {
  const applyTheme = (t: Theme) => {
    const root = document.documentElement
    if (t === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }

  const setTheme = (t: Theme) => {
    theme.value = t
    applyTheme(t)
    localStorage.setItem('cti-theme', t)
  }

  const toggleTheme = () => {
    setTheme(theme.value === 'light' ? 'dark' : 'light')
  }

  const initTheme = () => {
    if (isInitialized.value) return
    const stored = localStorage.getItem('cti-theme') as Theme | null
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const initial = stored ?? (prefersDark ? 'dark' : 'light')
    theme.value = initial
    applyTheme(initial)
    isInitialized.value = true
  }

  onMounted(initTheme)

  watch(theme, (t) => applyTheme(t))

  return { theme, toggleTheme, setTheme, initTheme }
}